module.exports = __webpack_public_path__ + "img/001.332ac834.jpg";